<template>
    <div class="node">
        <div class="title2" style="margin-top: 0px;">{{$t("node.title")}}</div>
        <div class="node-status">
            <div class="comments">
                <div class="comments-title">
                    <img src="@/assets/images/qai/question.png"/>
                    <span>{{$t('pledge.ruleLabel')}}：</span>
                </div>
                <p>{{$t("node.msg")}}</p>
            </div>

            <div class="nodeBox" :class="nodeData.normalNode?'light':'black'">
                <div class="lightIcon">
                    <img src="@/assets/images/mpc/light.png"/>
                </div>
                <div class="node-data">
                    <img src="@/assets/images/mpc/node-normal.png"/>
                    <div>
                        <span>{{$t("node.node3")}}</span>
                        <span>{{$t("node.nodeProfit3")}}</span>
                    </div>
                </div>
                <div class="node-task">
                    <div class="task">
                        <div class="left">
                            <span>{{$t("node.task")}}：</span>
                            <span>{{$t("node.nodeTask3")}}</span>
                        </div>
                        <div class="right2" @click="openUpgrade(3)" v-if="!nodeData.normalNode">{{$t("node.execute")}}</div>
                    </div>
                </div>
            </div>

            <div class="nodeBox" :class="nodeData.superNode?'light':'black'">
                <div class="lightIcon">
                    <img src="@/assets/images/mpc/light.png"/>
                </div>
                <div class="node-data">
                    <img src="@/assets/images/mpc/node-super.png"/>
                    <div>
                        <span>{{$t("node.node4")}}</span>
                        <span>{{$t("node.nodeProfit4")}}</span>
                    </div>
                </div>
                <div class="node-task">
                    <div class="task">
                        <div class="left">
                            <span>{{$t("node.task1")}}：</span>
                            <span>{{$t("node.inviteTask")}}</span>
                        </div>
                        <div class="right1" v-if="!nodeData.superNode">{{nodeData.inviteValidNum}} / 10</div>
                    </div>
                    <div class="task">
                        <div class="left">
                            <span>{{$t("node.task2")}}：</span>
                            <span>{{$t("node.nodeTask4")}}</span>
                        </div>
                        <div class="right2" @click="openUpgrade(4)" v-if="!nodeData.superNode">{{$t("node.execute")}}</div>
                    </div>
                </div>
            </div>

            <div class="nodeBox" :class="nodeData.createNode?'light':'black'">
                <div class="lightIcon">
                    <img src="@/assets/images/mpc/light.png"/>
                </div>
                <div class="node-data">
                    <img src="@/assets/images/mpc/node-create.png"/>
                    <div>
                        <span>{{$t("node.node5")}}</span>
                        <span>{{$t("node.nodeProfit5")}}</span>
                    </div>
                </div>
                <div class="node-task">
                    <div class="task">
                        <div class="left">
                            <span>{{$t("node.task1")}}：</span>
                            <span>{{$t("node.inviteTask")}}</span>
                        </div>
                        <div class="right1" v-if="!nodeData.createNode">{{nodeData.inviteValidNum}} / 10</div>
                    </div>
                    <div class="task">
                        <div class="left">
                            <span>{{$t("node.task2")}}：</span>
                            <span>{{$t("node.nodeTask5")}}</span>
                        </div>
                        <div class="right2" @click="openUpgrade(5)" v-if="!nodeData.createNode">{{$t("node.execute")}}</div>
                    </div>
                </div>
            </div>

            <div class="nodeBox" :class="nodeData.metaNode?'light':'black'">
                <div class="lightIcon">
                    <img src="@/assets/images/mpc/light.png"/>
                </div>
                <div class="node-data">
                    <img src="@/assets/images/mpc/node-meta.png"/>
                    <div>
                        <span>{{$t("node.node6")}}</span>
                        <span>{{$t("node.nodeProfit6")}}</span>
                    </div>
                </div>
                <div class="node-task">
                    <div class="task">
                        <div class="left">
                            <span>{{$t("node.task1")}}：</span>
                            <span>{{$t("node.inviteTask")}}</span>
                        </div>
                        <div class="right1" v-if="!nodeData.metaNode">{{nodeData.inviteValidNum}} / 10</div>
                    </div>
                    <div class="task">
                        <div class="left">
                            <span>{{$t("node.task2")}}：</span>
                            <span>{{$t("node.nodeTask6")}}</span>
                        </div>
                        <div class="right2" @click="openUpgrade(6)" v-if="!nodeData.metaNode">{{$t("node.execute")}}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="title2">{{$t("node.nodeBonus")}}</div>
        <div class="node-bonus">
            <div class="datas">
                <div class="bonus-data">
                    <span>{{showDataAuto(nodeData.takeAmt)}}</span>
                    <span>{{$t("node.takeAmt")}} (MPC)</span>
                </div>
                <div class="bonus-data">
                    <span>{{showDataAuto(nodeData.waitAmt)}}</span>
                    <span>{{$t("node.waitAmt")}} (MPC)</span>
                </div>
            </div>
            <div class="func" @click="confirmTake">{{$t("node.takeBonus")}}</div>
        </div>

        <div class="title2">{{$t("node.orderList")}}</div>
        <div class="orders" v-if="orderList && orderList.length>0">
            <div class="order" v-for="(item,index) in orderList" :key="index" :class="'status1'">
                <div class="status">
                    <span>{{$t("node.nodeOrder"+item.mode)}}</span>
                </div>
                <div class="content">
                    <p>
                        <span>{{$t("pledge.time")}}</span>
                        <span>{{formatTimestamp(item.buyTime * 1000,"yyyy-MM-dd hh:mm")}}</span>
                    </p>
                    <p>
                        <span>{{$t("pledge.amount")}}</span>
                        <span>{{convertUp(item.mpcAmt,18,2)}} MPC</span>
                    </p>
                    <p>
                        <span>{{$t("pledge.value")}}</span>
                        <span>{{convertUp(item.value,18,2)}} USDT</span>
                    </p>
                    <p>
                        <span>{{$t("pledge.profit")}}</span>
                        <span>{{convertUp(item.profit,18,2)}} MPC</span>
                    </p>
                    <!-- <p>
                        <span>已释放</span>
                        <span>{{convertUp(item.released,18,6)}} MPC</span>
                    </p>
                    <p>
                        <span>最近结算时间</span>
                        <span>{{formatTimestamp(item.lastTime * 1000,"yyyy-MM-dd hh:mm")}}</span>
                    </p> -->
                </div>
            </div>
        </div>
        <div class="noData" v-else>
            <img src="@/assets/images/qai/empty.png"/>
            <span>{{$t('common.noData')}}</span>
        </div>

        <el-dialog :visible.sync="boxVisible" class="myDialog UpgradeBox"
        :modal="true" :close-on-click-modal="false" :close-on-press-escape="false" :align-center="true" :show-close="false">
            <div class="myDialog-body">
                <i class="el-icon-circle-close myDialog-close" @click="boxVisible = false"></i>
                <div class="myDialog-title">{{$t("node.node"+curUpgrade)}}</div>
                <div class="desc">
                    <span>{{$t("node.nodeTask"+curUpgrade)}}</span>
                </div>
                <div class="payAmt">
                    <span>{{$t("node.needPay")}} <i>{{ showDataAuto(curPayAmount) }}</i> USDT</span>
                </div>
                <div class="balance">{{$t("common.balance")}}：{{ showDataAuto(myUsdtBalance) }} USDT</div>
                <div class="func" @click="confirmUpgrade">{{$t("common.confirm")}}</div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import bus from '@/assets/js/bus';
import { getUserName} from '@/assets/js/user';
import { getLanguage,setLanguage} from '@/assets/js/config';
import Web3 from 'web3';
export default {
	data() {
		return {
            walletAddress: "",
            web3Instance:null,
            mpcTeamContractInstance:null,
            mpcHomeContractInstance:null,
            tokenMpcContractInstance:null,
            tokenUsdtContractInstance:null,
            nodeData:{
                normalNode: false,
                superNode: false,
                createNode: false,
                metaNode: false,
                inviteValidNum: 0,
                takeAmt: 0,
                waitAmt: 0
            },
            curUpgrade:0,
            mpcPrice:0,
            curPayAmount:0,
            boxVisible:false,

            orderList:[],

            myUsdtBalance:0,
            nodeLimit:{
                normalNode:525,
                superNode:105,
                createNode:21,
                metaNode:10
            },
            nodeNum:{
                normalNode:0,
                superNode:0,
                createNode:0,
                metaNode:0
            }
		};
	},
    created() {
        bus.$off('clearWalletAddress');
        bus.$off('refreshWalletData');
        bus.$on('clearWalletAddress',async(msg) =>  {
            this.web3Instance = null;
            this.mpcTeamContractInstance = null;
            this.mpcHomeContractInstance = null;
            this.tokenMpcContractInstance = null;
            this.tokenUsdtContractInstance = null;
        });
        bus.$on('refreshWalletData',async(msg) =>  {
            this.walletAddress = getUserName();
            this.initWallet();
        });
    },
    mounted() {
        if(getUserName()){
            this.hideConnectWalletBox();
            this.walletAddress = getUserName();
            this.initWallet();
        }else{
            this.showConnectWalletBox();
            this.connectWallet();
        }
    },
    methods: {
        initWallet(){
            this.web3Instance = new Web3(window.ethereum);
            this.mpcTeamContractInstance = new this.web3Instance.eth.Contract(this.MpcTeam_Contract.abi, this.MpcTeam_Contract.address);
            this.mpcHomeContractInstance = new this.web3Instance.eth.Contract(this.MpcHome_Contract.abi, this.MpcHome_Contract.address);
            this.tokenMpcContractInstance = new this.web3Instance.eth.Contract(this.TokenMpc_Contract.abi, this.TokenMpc_Contract.address);
            this.tokenUsdtContractInstance = new this.web3Instance.eth.Contract(this.TokenUsdt_Contract.abi, this.TokenUsdt_Contract.address);
            this.refreshWalletData();
        },
        refreshWalletData(){
            this.showLoadingBox();
            this.mpcHomeContractInstance.methods.findNodePool().call().then((result) => {
                let bonusPool = {
                    _nodeNormalPool: this.convertFromByUnit(result._nodeNormalPool,18),
                    _nodeSuperPool: this.convertFromByUnit(result._nodeSuperPool,18),
                    _nodeCreatePool: this.convertFromByUnit(result._nodeCreatePool,18),
                    _nodeMetaPool: this.convertFromByUnit(result._nodeMetaPool,18)
                }
                console.log("bonusPool:",bonusPool);
            });
            this.tokenUsdtContractInstance.methods.balanceOf(this.walletAddress).call().then((result) => {
                this.myUsdtBalance = this.convertFromByUnit(result,18);
            });
            this.mpcHomeContractInstance.methods.calcMpcPrice().call().then((result) => {
                this.mpcPrice = this.convertFromByUnit(result,18)
            });
            this.mpcHomeContractInstance.methods.findUserNodeData(this.walletAddress).call().then((result) => {
                console.log("findUserNodeData:",result);
                this.hideLoadingBox();
                this.nodeData = {
                    normalNode: result.nodeData.normalNode,
                    superNode: result.nodeData.superNode,
                    createNode: result.nodeData.createNode,
                    metaNode: result.nodeData.metaNode,
                    inviteValidNum: parseInt(result.inviteValidNum),
                    takeAmt: this.convertFromByUnit(result.takeAmt,18),
                    waitAmt: this.convertFromByUnit(result.waitAmt,18)
                }
                console.log(this.nodeData)
            });
            this.mpcHomeContractInstance.methods.findNodeSize().call().then((result) => {
                console.log("findNodeSize:",result);
                this.nodeNum = {
                    nodeNormalSize: parseInt(result._nodeNormalSize),
                    nodeSuperSize: parseInt(result._nodeSuperSize),
                    nodeCreateSize: parseInt(result._nodeCreateSize),
                    nodeMetaSize: parseInt(result._nodeMetaSize)
                }
            });
            this.mpcHomeContractInstance.methods.findUserNodeOrders(this.walletAddress).call().then((result) => {
                console.log("findUserNodeOrders:",result);
                this.hideLoadingBox();
                let orderList = [];
                for(let order of result){
                    orderList.push(order);
                }
                orderList.reverse();
                this.orderList = orderList;
            });
        },
        openUpgrade(mode){
            this.curUpgrade = mode;
            if(this.curUpgrade == 3){
                this.curPayAmount = 1000 * this.mpcPrice;
            }else if(this.curUpgrade == 4){
                this.curPayAmount = 5000 * this.mpcPrice;
            }else if(this.curUpgrade == 5){
                this.curPayAmount = 10000 * this.mpcPrice;
            }else if(this.curUpgrade == 6){
                this.curPayAmount = 50000 * this.mpcPrice;
            }
            this.boxVisible = true;
        },
        async confirmUpgrade(){
            let _this = this;
            if(!this.mpcHomeContractInstance){
                return;
            }
            if(this.curUpgrade == 4 || this.curUpgrade == 5 || this.curUpgrade == 6){
                if(this.nodeData.inviteValidNum < 10){
                    this.$message.warning({message: this.$t("node.plsFinishTask1"),duration: 1500})
                    return;
                }
            }
            if(this.curPayAmount > this.myUsdtBalance || this.myUsdtBalance <= 0){
                this.$message.warning({message: this.$t("common.usdtBalanceOut"),duration: 1500})
                return;
            }
            if(this.curUpgrade == 3){
                if(this.nodeNum.normalNode >= this.nodeLimit.normalNode){
                    this.$message.warning({message: this.$t("node.node0SoldOut"),duration: 1500})
                    return;
                }
            }else if(this.curUpgrade == 4){
                if(this.nodeNum.superNode >= this.nodeLimit.superNode){
                    this.$message.warning({message:this.$t("node.node1SoldOut"),duration: 1500})
                    return;
                }
            }else if(this.curUpgrade == 5){
                if(this.nodeNum.createNode >= this.nodeLimit.createNode){
                    this.$message.warning({message:this.$t("node.node2SoldOut"),duration: 1500})
                    return;
                }
            }else if(this.curUpgrade == 6){
                if(this.nodeNum.metaNode >= this.nodeLimit.metaNode){
                    this.$message.warning({message:this.$t("node.node3SoldOut"),duration: 1500})
                    return;
                }
            }
            this.showConfirmBox(2,"USDT");
            let usdtFinalBigNumber = this.convertToBigNumberByUnit(this.curPayAmount,18);
            let usdtAllowance = await this.tokenUsdtContractInstance.methods.allowance(this.walletAddress, this.MpcHome_Contract.address).call();
            let usdtAllowanceBigInt = this.convertToBigIntByUnit(usdtAllowance,0);
            let finalBigInt = this.convertToBigIntByUnit(this.curPayAmount,18);
            if(finalBigInt > usdtAllowanceBigInt){
                if(!await this.tokenApprove(this.tokenUsdtContractInstance,this.walletAddress,this.MpcHome_Contract.address,usdtFinalBigNumber)){
                    this.$message.warning({message:  this.$t("common.approveUsdtFail"),duration: 1500});
                    this.hideConfirmBox();
                    return;
                }
            }
            this.setConfirmBox(2);
            let method = this.mpcHomeContractInstance.methods.upgradeNode(this.curUpgrade);
            let bnbAmount = null;

            let gasprice = await this.web3Instance.eth.getGasPrice();
            console.log("gasPrice:",gasprice);
            method.estimateGas({from: this.walletAddress, value:bnbAmount}).then(function(result){
                console.log("estimateGas:",result);
            }).catch((err) => {
                console.log("estimateGas:",err)
            });

            this.contractSend(method,this.walletAddress,bnbAmount).then(function(result){
                _this.hideConfirmBox();
                if(result.status){
                    _this.$message.success({message: _this.$t("node.upgradeSuccess"),duration: 1500});
                    _this.boxVisible = false;
                    _this.refreshWalletData();
                }else{
                    _this.$message.error({message: _this.$t("node.upgradeFail"),duration: 1500});
                }
            }).catch((err) => {
                _this.hideConfirmBox();
                _this.$message.error({message: _this.$t("node.upgradeFail"),duration: 1500});
            });
        },
        async confirmTake(){
            let _this = this;
            if(!this.mpcHomeContractInstance){
                return;
            }
            if(this.nodeData.waitAmt <= 0){
                this.$message.warning({message: this.$t("node.noBonus") ,duration: 1500})
                return;
            }
            let method = this.mpcHomeContractInstance.methods.takeNodeBonus();
            let bnbAmount = null;

            let gasprice = await this.web3Instance.eth.getGasPrice();
            console.log("gasPrice:",gasprice);
            method.estimateGas({from: this.walletAddress, value:bnbAmount}).then(function(result){
                console.log("estimateGas:",result);
            }).catch((err) => {
                console.log("estimateGas:",err)
            });

            this.contractSend(method,this.walletAddress,bnbAmount).then(function(result){
                _this.hideConfirmBox();
                if(result.status){
                    _this.$message.success({message: _this.$t("node.takeSuccess"),duration: 1500});
                    _this.refreshWalletData();
                }else{
                    _this.$message.error({message: _this.$t("node.takeFail"),duration: 1500});
                }
            }).catch((err) => {
                _this.hideConfirmBox();
                _this.$message.error({message: _this.$t("node.takeFail"),duration: 1500});
            });
        }
    },
    beforeDestroy() {
    }
};
</script>
<style lang="less">
.UpgradeBox{
    .myDialog-body {
        padding: 20px 20px !important;
        .desc{
            margin: 15px 0px;
            font-size: 14px;
            text-align: center;
            color: #9ABCDF;
        }
        .payAmt{
            // padding: 15px 10px;
            padding: 25px 0px 25px 0px;
            background:url('~@/assets/images/mpc/bg-input2.png') 0px 0px no-repeat;
            background-size: 100% 100%;
            // border-radius: 5px;
            // background: rgba(255,255,255,0.13);
            color: #00CCFF;
            font-size: 16px;
            font-weight: 600;
            i{
                font-style: normal;
                font-size: 22px;
                color: #00CCFF;
                font-weight: 800;
            }
        }
        .balance{
            margin-top: 20px;
            font-size: 13px;
            text-align: center;
            color: #9ABCDF;
        }
        .func {
            margin-top: 10px;
            font-size: 14px;
            height: 45px;
            line-height: 45px;
            color:#000000;
            text-align: center;
            cursor: pointer;
            background:url('~@/assets/images/mpc/bg-btn.png') 0px 0px no-repeat;
            background-size: 100% 100%;
        }
    }
}
</style>
<style lang='less' scoped>
.node{
    padding-top: 10px;
    padding-bottom: 150px;
    .node-status{
        margin:0px 10px;
        background:url('~@/assets/images/mpc/bg-nodebox.png') 0px 0px no-repeat;
        background-size: 100% 100%;
        padding: 25px 15px 25px 15px;
        .comments{
            // margin-top: 15px;
            padding: 18px 20px;
            background:url('~@/assets/images/mpc/bg-msg.png') 0px 0px no-repeat;
            background-size: 100% 100%;
            color: #ffffff;
            .comments-title{
                display: flex;
                align-items: center;
                img{
                    width: 13px;
                    height: 13px;
                    margin-right: 3px;
                }
                span{
                    font-size: 12px;
                    font-weight: bold;
                }
            }
            p{
                margin: 6px 0px 0px 0px;
                padding:0px;
                font-size: 12px;
                text-align: left;
                color: #9ABCDF;
            }
        }
        .nodeBox.light{
            background:url('~@/assets/images/mpc/bg-node2.png') 0px 0px no-repeat;
            background-size: 100% 100%;
            opacity: 1;
            .lightIcon{
                display: block;
            }
        }
        .nodeBox.black{
            background:url('~@/assets/images/mpc/bg-node.png') 0px 0px no-repeat;
            background-size: 100% 100%;
            // opacity: 0.8;
            .lightIcon{
                display: none;
            }
        }
        .nodeBox{
            margin-top: 5px;
            padding: 18px 10px;
            color: #ffffff;
            position: relative;
            .lightIcon{
                position: absolute;
                right: 15px;
                top: 15px;
                img{
                    width: 25px;
                    height: auto;
                }
            }
            .node-data{
                display: flex;
                align-items: center;
                justify-content: flex-start;
                img{
                    width: 70px;
                    height: auto;
                    margin-right: 5px;
                }
                div{
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    gap:5px;
                    span:first-child{
                        font-size: 15px;
                        color: #ffffff;
                        font-weight: bolder;
                        text-align: left;
                    }
                    span:last-child{
                        font-size: 13px;
                        color: #9ABCDF;
                        text-align: left;
                        line-height: 14px;
                    }
                }
            }
            .node-task{
                display: flex;
                flex-direction: column;
                gap:5px;
                margin-top: 10px;
                .task{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .left{
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        font-size: 13px;
                        color: #9ABCDF;
                        text-align: left;
                        span:first-child{
                            color:#00CCFF;
                            word-break: keep-all;
                        }
                    }
                    .right1{
                        font-size: 13px;
                        color: #ffffff;
                    }
                    .right2{
                        width: 60px;
                        font-size: 11px;
                        height: 22px;
                        line-height: 22px;
                        color:#000000;
                        text-align: center;
                        cursor: pointer;
                        background:url('~@/assets/images/mpc/bg-btn2.png') 0px 0px no-repeat;
                        background-size: 100% 100%;
                    }
                }
            }
        }
    }

    .node-bonus{
        margin:0px 10px;
        padding: 25px 20px 30px 20px;
        background:url('~@/assets/images/mpc/bg-bonus.png') 0px 0px no-repeat;
        background-size: 100% 100%;
        .datas{
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .bonus-data{
            display: flex;
            flex-direction: column;
            // gap:5px;
            span:first-child{
                font-weight: bolder;
                font-size: 25px;
                color: #FFFFFF;
            }
            span:last-child{
                font-size: 13px;
                // color: #747A9A;
                color: #9ABCDF;
            }
        }
        .bonus-data:first-child{
            align-items: flex-start;
        }
        .bonus-data:last-child{
            align-items: flex-end;
        }
        .func {
            margin-top: 25px;
            font-size: 14px;
            height: 45px;
            line-height: 45px;
            color:#000000;
            text-align: center;
            cursor: pointer;
            background:url('~@/assets/images/mpc/bg-btn.png') 0px 0px no-repeat;
            background-size: 100% 100%;
        }
    }

    .orders{
        margin: 10px 10px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        .order{
            background:url('~@/assets/images/mpc/bg-order.png') 0px 0px no-repeat;
            background-size: 100% 100%;
            padding: 12px 15px;
            .status{
                display: flex;
                align-items: center;
                margin-bottom: 5px;
                img{
                    // width: 14px;
                    height: 25px;
                    width: auto;
                    margin-right: 8px;
                }
                span{
                    font-size: 15px;
                    font-weight: bold;
                    color: #ffffff;
                }
            }
            .content{
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: 5px;
                p{
                    padding: 0px;
                    margin: 0px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    span:first-child{
                        font-size: 13px;
                        color: #9ABCDF;
                    }
                    span:last-child{
                        font-size: 14px;
                        color: #ffffff;
                    }
                }
            }
        }
    }
}
</style>